/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { configurationServices } from "../../constants/configurationServices";
import { useTranslation } from "react-i18next";
import {
	Autocomplete,
	Button,
	FormControl,
	FormHelperText,
	Grid,
	TextField,
	Typography
} from "@mui/material";
import { LocalizationProvider, DesktopDatePicker } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { Box } from "@mui/system";
import LoadingButton from "@mui/lab/LoadingButton";
import Header from "../../components/layout/Header";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { forgotUsenameService } from "../../services/auth.service";
import { userName } from "../../constants/ImageConstants";
import { analytics } from "../../utils/analytics/analytics";
import useDirectionHook from "../../hooks/useDirectionHook";
import { removeForgotUsername } from "../../reducers/signUpSlice";
import { notifyApiFail } from "../../reducers/errorNotifySlice";
import FXCMTrans from "../../components/common/FXCMTrans";
import { DateTime } from "luxon";
import { resolveCountryBlockedMessage, isCountryBlockedResponse } from "../../utils/countryBlocked";
import "./style.scss";
import CountryFlagsComponent from '../../components/CountryFlagsComponent';
import DOMPurify from 'dompurify';

const ForgotUsername = () => { //NOSONAR
	const minEligibleDOB = DateTime.now().minus({ years: 18 });
	const { t: getLabel } = useTranslation();
	const navigate = useNavigate();
	const [config, setConfig] = useState();
	const dispatch = useDispatch();
	const [error, setError] = useState({
		lastname: false,
		email: false,
		phonenumber: false
	});
	const { forgotUserRes, getAllEnLabels, forgotUserResSucc } = useSelector((state) => state.signUp);
	const { languageParam, user } = useSelector((state) => state.signUp);
	const [direction] = useDirectionHook(languageParam);

	const [dateValue, setDateValue] = useState(null);
	const [age, setAge] = useState();
	const [countryCodeError, setCountryCodeError] = useState(false);
	const [phoneCountry, setphoneCountry] = useState();
	const [countryCode, setCountryCode] = useState("");
	const [countriesList, setCountryList] = useState();
	const[buttonLoader, setButtonLoader] = useState(false);
	// CX-51004: COUNTRY_BLOCKED_MESSAGE_N bucket routing needs the same
	// restrictedCountries.json config SignUpForm.js already loads.
	const [restrictedCountriesList, setRestrictedCountriesList] = useState();
	const [values, setValues] = useState({
		lastname: "",
		email: "",
		dob: dateValue,
		phonenumber: "",
		phoneCountry: phoneCountry
	});
	const defaultLocale = DOMPurify.sanitize(localStorage.getItem("i18nextLng"));
	const [dateFormateValidation,setDateFormateValidation] = useState(false) 
	const [hasProcessed, setHasProcessed] = useState(false);
	// CX-51004: country-of-residence block (CX-51003), shown inline and persistently.
	// A flag, not the resolved copy — storing the string would freeze it in the
	// language active at block time and it would not follow a language switch.
	const [countryBlocked, setCountryBlocked] = useState(false);
	// CX-51004 follow-up: the effect below dispatches removeForgotUsername()
	// (resets forgotUserRes to {}) in the same tick it detects the block, so
	// forgotUserRes?.errData?.blockedCountry is only available for one render.
	// Captured here so getCountryBlockedMessage still has a country code once
	// forgotUserRes is cleared — otherwise message-bucket (and any per-country
	// override) routing silently loses its country code and falls back to the
	// generic copy.
	const [blockedCountryCode, setBlockedCountryCode] = useState(null);
	// CX-51004/CX-51021: resolved async (cross-entity aware — see countryBlocked.js),
	// not at render, since the correct entity's bundle now has to be fetched
	// directly rather than read off the currently loaded i18next instance.
	const [countryBlockedMessage, setCountryBlockedMessage] = useState(null);

/* istanbul ignore next */
	const updateAboutUser = (newValue, type) => {
		if (type === "dob") {
			if(newValue?.c){
			const DOB = newValue?.toFormat("yyyy-MM-dd");
			const now = DateTime.now().startOf("day");
			const dobDate = DateTime.local(newValue?.c?.year, newValue?.c?.month, newValue?.c?.day).startOf("day");
			const diff = now.diff(dobDate, ["years", "months", "days"]);
			const exactAge = diff.years + diff.months / 12 + diff.days / 365; 
			setAge(exactAge);
			setDateValue(newValue);
			setValues({ ...values, dob: DOB });
			} else{
				const DOB = newValue?.toFormat("yyyy-MM-dd");
				setAge(newValue === null ? undefined : newValue);
				setDateValue(newValue);
				setValues({ ...values, dob: DOB });
			}
		}
	};
	
	/* istanbul ignore next */
	useEffect(() => {
		// Check if the response is already processed
		if (!hasProcessed && forgotUserRes) {
		if (
			forgotUserRes?.success &&
			Object.keys(forgotUserRes).length !== 0
		) {
			dispatch(removeForgotUsername());
			navigate("/forgotUsernameConfirm", {
			state: { email: values.email, success: forgotUserResSucc },
			});
			setButtonLoader(false);
			setHasProcessed(true); // Set to true to stop further effect execution
			// CX-51023: a prior COUNTRY_BLOCKED submit leaves this true forever
			// otherwise — the banner would keep showing even after a later
			// successful submit (mirrors Login.js's equivalent reset).
			setCountryBlocked(false);
			setBlockedCountryCode(null);
		}
		// CX-51004: country-of-residence block (CX-51003). Checked before the
		// invalid-details branch below: the block is a 401, so it would otherwise
		// match no branch at all and the form would sit with the spinner cleared
		// and nothing shown. Copy is resolved from the bundles, not from the
		// backend's English `reason`, since locale is owned by the frontend.
		if (
			isCountryBlockedResponse(forgotUserRes) &&
			Object.keys(forgotUserRes).length !== 0
		) {
			// Rendered inline rather than through notifyApiFail: FXCMErrorNotification
			// auto-dismisses after 10s, and a regulatory blocking notice must not vanish
			// while the user is reading it.
			setCountryBlocked(true);
			setBlockedCountryCode(forgotUserRes?.errData?.additionalProperties?.countryOfResidence);
			dispatch(removeForgotUsername());
			setButtonLoader(false);
			setHasProcessed(true);
		} else if (
			forgotUserRes?.errData?.status === 400 &&
			Object.keys(forgotUserRes).length !== 0
		) {
			dispatch(
				notifyApiFail({
					title: getLabel("INVALID_DETAILS_TITLE"),
					desc: getLabel("INVALID_DETAILS_SUBTITLE"),
					type: "error",
				})
			);
			dispatch(removeForgotUsername());
			setButtonLoader(false);
			// CX-51023: same reset as the success branch above — a prior block
			// must not keep showing once a later, differently-shaped response
			// (here, plain invalid details) comes back.
			setCountryBlocked(false);
			setBlockedCountryCode(null);
		}
		}
	}, [forgotUserRes, navigate, values, hasProcessed, dispatch]);

	// CX-51004/CX-51021: resolves the block copy from the blocked country's
	// OWNING entity bundle (see countryBlocked.js) rather than whatever entity
	// i18next currently has loaded. Re-runs on languageParam so a language
	// switch after the block still re-translates this message.
	useEffect(() => {
		let cancelled = false;
		if (countryBlocked && blockedCountryCode) {
			resolveCountryBlockedMessage(getLabel, blockedCountryCode, restrictedCountriesList, languageParam).then(
				(message) => {
					if (!cancelled) setCountryBlockedMessage(message);
				}
			);
		} else {
			setCountryBlockedMessage(null);
		}
		return () => {
			cancelled = true;
		};
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [countryBlocked, blockedCountryCode, restrictedCountriesList, languageParam]);

	const emailRegex =
		/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test( // NOSONAR
			values.email
		);

/* istanbul ignore next */
	const handleChange = (prop) => (event, newValue) => {
		setValues({ ...values, [prop]: event.target.value });

		if (prop === "dob") {
			const DOB = DateTime.fromJSDate(new Date(newValue)).toFormat("dd-MM-yyyy")
			setValues({ ...values, [prop]: DOB });
			setAge(Math.floor(DateTime.now().diff(newValue, "years").years), "age");
			setDateValue(newValue);
		}
		if (
			event?.target?.value?.includes("fuhui") ||
			event?.target?.value?.includes("fxcm")
		) {
			setError({ ...error, email: true });
		}
	};
 
/* istanbul ignore next */
	const handleBlurEmail = () => {
		if (emailRegex) {
			setError({ ...error, email: false });
		} else {
			setError({ ...error, email: true });
		}
	};

/* istanbul ignore next */
	const handleCancelClick = () => {
		analytics?.trackEvent("targeted_click", { engagementContext:  getAllEnLabels["CANCEL"] });
		navigate("/login");
	};

	const ageData = {
		column: 12,
		label: "dob",
		maxAge: 100,
		minAge: 18,
		required: true,
		type: "AgeDatePicker",
		value: "dob",
	};
 
/* istanbul ignore next */
	const validation = () => {
		let isValid = true;
		if (error.lastname || error.email || error.phonenumber) {
			isValid = false; // NOSONAR
		}
		if (
			values.email === "" ||
			values.lastname === "" ||
			values.phonenumber === ""
		) {
			isValid = false; // NOSONAR
		}
		if (age < ageData.minAge || age > ageData.maxAge || !dateValue) {
			isValid = false;
		} else {
			isValid = true;
		}
		return isValid;
	};

	useEffect(() => {
    if (dateValue) {
      const formattedDate = dateValue.toFormat(
        defaultLocale === "zh-CN" || defaultLocale === "zh-TW"
          ? "yyyy/MM/dd"
          : "MM/dd/yyyy"
      );
      const jsDate = dateValue?.toJSDate();
      let formatValidation =
        DateTime.fromJSDate(jsDate).toFormat(
          defaultLocale === "zh-CN" || defaultLocale === "zh-TW"
            ? "yyyy/MM/dd"
            : "MM/dd/yyyy"
        ) === formattedDate;
      setDateFormateValidation(formatValidation);
    }
  }, [dateValue]);

	/* istanbul ignore next */
	const datePickerFormatLabel = (defaultLocale === "zh-CN" || defaultLocale === "zh-TW") ? "yyyy/MM/dd" : "MM/dd/yyyy" ;	 
	 
/* istanbul ignore next */
	const dateValidation =
		age < ageData.minAge || age > ageData.maxAge || dateValue === null;
		
	/* istanbul ignore next */
	const handleSubmit = (e) => {
		e.preventDefault();
		let emailError = false;
		let lastnameError = false;
		let phonenumberError = false;

		if (values.email === "") {
			emailError = true;
		}
		if (values.username === "") {
			lastnameError = true;
		}

		if (values.phonenumber === "") {
			lastnameError = true;
		}

		setError({
			...error,
			email: emailError,
			lastname: lastnameError,
			phonenumber: phonenumberError,
		});

		if (validation()) {
			setButtonLoader(true);
			// CX-51023: hasProcessed latches true after any prior response is
			// processed (success, COUNTRY_BLOCKED, or invalid-details) and is never
			// reset elsewhere -- without this, a second submit's response effect
			// guard (`!hasProcessed`) stays permanently false, so its own
			// setButtonLoader(false)/navigate never runs and the button spins forever.
			setHasProcessed(false);
			window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
			setValues({ ...values });
			analytics?.trackEvent("forgot_username", {});
			dispatch(forgotUsenameService(values));
		}
	};
 
/* istanbul ignore next */
	const fetchJson = () => {
		fetch(configurationServices().LogInURL)
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				setConfig(data);
			})
			.catch((e) => {
				console.log(e.message);
			});
	};
	useEffect(() => {
		fetchJson();
	}, []);
 
/* istanbul ignore next */
	const fetchCountryJson = () => {
		let countriesList = configurationServices().countryList;
		fetch(countriesList)
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				setCountryList(data);
			})
			.catch((e) => {
				console.log(e.message);
			});
	};

	useEffect(() => {
		fetchCountryJson();
	}, []);
/* istanbul ignore next */
	const fetchFxcmRestrictedCountriesJson = () => {
		fetch(configurationServices().restrictedCountriesURL)
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				setRestrictedCountriesList(data);
			})
			.catch((e) => {
				console.log(e.message);
			});
	};
	useEffect(() => {
		fetchFxcmRestrictedCountriesJson();
	}, []);
	/* istanbul ignore next */
	function countryToFlag(value) {
		const code = value?.split(" ")[0];
		setCountryCode(code);
		if (Array.isArray(countriesList)) {
			return countriesList?.find((country) => country.country_code === code)?.country_code;
		}
		return undefined;
	}

	let enabled = !(emailRegex && values.email !== "" && values.lastname !== "" && values.phonenumber && !dateValidation && countryCode !== "" && dateFormateValidation);

	return (
		<Box mt="144px">
            <Header screenType="forgotusername" />
			<Box sx={{ mt: "97px" }}>
				<div className="container-home forgot-username">
					<Box textAlign="center">
						<img src={userName} alt="logInIcon" id="login-icon" width="57" height="56" className="cardIcon" />
						<Typography className="heading-1" id="forgot-username-title" sx={{ mt: "20px" }}>
							{getLabel(config?.FORGET_USERNAME_TITLE)}
						</Typography>
					</Box>

					<form>
						<FormControl
							fullWidth
							sx={{ mt: "20px" }}
							className={
								direction.status
									? "custom-form-controler custom_form_controler_arabic"
									: "custom-form-controler"
							}
						>
							<TextField
								id="forgot-username-lastname"
								value={values.lastname}
								label={getLabel(config?.LASTNAME)}
								onChange={handleChange("lastname")}
								inputProps={{ maxLength: 50 }}
								error={error.lastname ? true : false}
								helperText={
									error.lastname && config && config.MANDATORY_CHECK //NOSOANAR
										? getLabel(config.MANDATORY_CHECK)
										: ""
								}
							/>
						</FormControl>

						<FormControl
							fullWidth
							sx={{ mt: "20px" }}
							className={
								direction.status
									? "custom_form_controler_arabic custom-form-controler cutome-date-picker"
									: "custom-form-controler  cutome-date-picker"
							}
						>
							<LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale={languageParam}>
								<DesktopDatePicker
									label={getLabel(config?.DATE_OF_BIRTH)}
									value={dateValue}
									onChange={	/* istanbul ignore next */
										( newValue ) =>
										updateAboutUser(newValue, ageData.label)
									}
									className={
										age < ageData.minAge ||
										age > ageData.maxAge ||
										dateValue?.c === null
										? ""
										: "input-text-normal"
									}																	
									inputFormat={datePickerFormatLabel}
									minDate={
										DateTime.now().minus({ years: ageData.maxAge }).toJSDate()
									}
									maxDate={
										DateTime.now().minus({ years: ageData.minAge }).toJSDate()
									}
									disableFuture
									defaultCalendarMonth={minEligibleDOB}
									renderInput={({ error, ...params }) => {
										
										return (
											<TextField
											id="forgot-username-datepicker"
											error={
												age < ageData.minAge ||
												age > ageData.maxAge ||
												dateValue?.c === null
											}
											helperText={
												(age && (age < ageData.minAge || age > ageData.maxAge))
												? getLabel("AGE_DURATION")
												: dateValue?.c === null && user?.countryOfResidence === "CN" ? getLabel("DATE_FORMAT")//NOSONAR
												: dateValue?.c === null//NOSONAR
												? getLabel(["zh-CN","zh-TW"].includes(defaultLocale) ? "VALID_DATE_CHINA" : "VALID_DATE")//NOSONAR
												: ["zh-CN","zh-TW"].includes(defaultLocale)   ? getLabel("DATE_FORMAT") : 'mm/dd/yyyy' //NOSONAR
											}											
											{...params}
										/>
										)

									}}
								/>
							</LocalizationProvider>
						</FormControl>

						<FormControl
							fullWidth
							sx={{ mt: "20px" }}
							className={
								direction.status
									? "custom-form-controler custom_form_controler_arabic"
									: "custom-form-controler"
							}
						>
							<TextField
								value={values.email}
								id="forgot-username-email"
								label={getLabel(config?.EMAIL)}
								onChange={handleChange("email")}
								name="email"
								inputProps={{ maxLength: 50 }}
								onBlur={handleBlurEmail}
							/>
						</FormControl>

						<Box display="flex" sx={{ mt: "30px" }}>
							<Grid container spacing={1} className="custom-form-controler">
								<Grid item xs={4}>
									<Autocomplete
										id="forgot-username-country-code"
										slotProps={{
											popupIndicator: {
												id: "forgot-username-country-open-btn"
											},
											clearIndicator: {
												id: "forgot-username-country-clear-btn"
											},
										}}
										//sx={{width: "145px"}}
										options={countriesList}
										className="contact-auto-complete no-asterisk forgot-usernam-auto custom-form-label custom-autocomplete-endAdornment"
										getOptionLabel={	/* istanbul ignore next */
											( option ) =>
											`${option?.country_code} (+${option?.phone_prefix})`
										}
										value={phoneCountry}
										onChange={/* istanbul ignore next */
											(event, newValue) => {	
											setphoneCountry(newValue?.country_code);	
											setValues({ 
												...values,
												phoneCountry: newValue?.country_code
											});
											if (!newValue) setCountryCode("");
											else setCountryCodeError(false);
										}}
										clearIcon
										renderOption={/* istanbul ignore next */
											( props, option ) => (
											<Box
												component="li"
												marginLeft={"-20px"}
												sx={{ "& > img": { mr: 1, flexShrink: 0 } }}
												{...props}
											>
												<CountryFlagsComponent class="username-flags" size={20} countryCode={option?.country_code} />
												{option?.country_code}(+{option?.phone_prefix})
											</Box>
										)}
										renderInput={(params) => {
											return (
												<>
													{params?.inputProps?.value && (
														<span
															style={{
																position: "absolute",
																transform: "translateY(50%)",
																marginLeft: "15px"
															}}
														>
														<CountryFlagsComponent 
															class="username-flags"
															size={20}
															countryCode={countryToFlag(params?.inputProps.value)}
														/>
														</span>
													)}
													<TextField
														{...params}
														// className="custom-form-controler"
														label={getLabel("COUNTRY_CODE")}
														inputProps={{
															...params.inputProps,
															style: { marginLeft: "20px", height: "25px" }
														}}
														sx={{
															"& label": {
																padding: "1px",
																fontSize: "14px"
															}
														}}
														error={countryCodeError}
														helperText={
															countryCodeError ? (
																<FXCMTrans
																	defaults={getLabel("MANDATORY_CHECK")}
																/>
															) : (
																""
															)
														}
														size="small"
													/>
												</>
											);
										}}
									/>
								</Grid>
								<Grid item xs={6}>
									<FormControl
									    fullWidth
										className={
											direction.status
												? "custom-form-controler custom_form_controler_arabic"
												: "custom-form-controler"
										}
									>
										<TextField
											sx={{ width: "135%" }}
											id="forgot-username-phone"
											label={getLabel(config?.PHONE_NUMBER)}
											value={values.phonenumber}
											onChange={handleChange("phonenumber")}
											type="number"
											error={error.phonenumber ? true : false}
											helperText={
												error.lastname ? getLabel(config?.MANDATORY_CHECK) : ""
											}
										/>
									</FormControl>
								</Grid>
							</Grid>
						</Box>

						{countryBlocked && countryBlockedMessage && (
							// `error` is required for visual parity with the login screen: the
							// `.forgot-username` scope in pages/authentication/style.scss resets
							// helper text to plain grey and only restores the red-on-pink error
							// box under `&.Mui-error`, which MUI adds from this prop.
							<FormControl error fullWidth className={direction.status ? "custom-form-controler custom_form_controler_arabic" : "custom-form-controler"}>
								<FormHelperText id="forgot-username-country-blocked">
									<FXCMTrans 
										defaults={countryBlockedMessage}
										values={{country: blockedCountryCode, lang: languageParam?.split("-")[0]}}
									></FXCMTrans>
								</FormHelperText>
							</FormControl>
						)}

						<Box sx={{ mt: 3 }}>
							<Grid container spacing={1} className="forgot-button">
								<Grid item xs={6}>
									<Button
										id="forgot-username-cancel-btn"
										fullWidth
										variant="outline"
										sx={{ my: 1 }}
										onClick={handleCancelClick}
									>
										{getLabel("CANCEL")}
									</Button>
								</Grid>
								<Grid item xs={6}>
									<LoadingButton
										id="forgot-username-submit-btn"
										loading={buttonLoader}
										loadingPosition="end"
										type="submit"
										disabled={enabled}
										fullWidth
										sx={{ mt: 1 }}
										variant="contained"
										onClick={handleSubmit}
									>
										{getLabel("SUBMIT")}
									</LoadingButton>
								</Grid>
							</Grid>
						</Box>
					</form>
				</div>
			</Box>
        </Box>
	);
};

export default ForgotUsername;
